export default __webpack_public_path__ + "e2b71dd8acee278e37f13f67b5866e24.png";